module.exports = __webpack_public_path__ + "img/h2.a0506f20.svg";